const RandomIdThatWouldNotMatchAnything = 'f43bc690-58b2-4755-8ddd-ae0cae2f4c51';

export class Workstation {
  constructor(public readonly id: string) {}

  static none(): Workstation {
    return new Workstation(RandomIdThatWouldNotMatchAnything);
  }
}
